export default {
    url: '/targets',
    template: `
        <courses-courses-edit-occurrence-automated-planning-group-edit-targets
            planning-group="vm.planningGroup"
        />
    `,
    controller ($scope) {
        $scope.$parent.vm.step = 2;
        this.planningGroup = $scope.$parent.vm.planningGroup;
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/courses/courses/edit/occurrence/automated/edit/targets/index.js